import 'bootstrap/dist/css/bootstrap.min.css'; 
import Roll from 'react-reveal/Roll';


function HtmlCssSection(props) {
    return (
            <Roll left className="DS">  
                <div className="htmlcss leaves p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Leafs</h3>
                    <div className="leaf blue-leaf"></div>
                    <div className="leaf green-leaf"></div>
                    <div className="leaf yellow-leaf"></div>
                </div>
                <div className="htmlcss fork p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Fork</h3>
                    <div className="stem"></div>
                    <div className="base"></div>
                    <div className="prongs prong-1"></div>
                    <div className="inner-prongs inner-prong-1"></div>
                    <div className="prongs prong-2"></div>
                    <div className="inner-prongs inner-prong-2"></div>
                    <div className="prongs prong-3"></div>
                    <div className="inner-prongs inner-prong-3"></div>
                    <div className="prongs prong-4"></div>
                </div>
                <div className="htmlcss cube p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Cube</h3>
                    <p className='pa'></p>
                    <p className='pb'></p>
                    <p className='pc'></p>
                </div>
                <div className="htmlcss nword p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>N Word</h3>
                    <div className="line1"></div>
                    <div className="line2"></div>
                    <div className="line3"></div>
                </div>
                <div className="htmlcss curtain p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Curtains</h3>
                    <div className='b'></div>
                </div>
                <div className="htmlcss sunrays p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Sun Rays</h3>
                    <div className='b'></div>
                    <div className='r'></div>
                    <div className='i'></div>
                    <div className='z'></div>
                    <div className='i2'></div>
                    <div className='r2'></div>
                </div>
                <div className="htmlcss rainDrops p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Rain Drops</h3>
                    <div className='b'></div>
                    <div className='r'></div>
                    <div className='i'></div>
                </div>
                <div className="htmlcss blackLight p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Black Light</h3>
                    <div className='b'></div>
                </div>
                <div className="htmlcss randomBox p-2 col-12 col-lg-4 col-md-6 col-sm-6 border">
                    <h3>Random Box</h3>
                    <div className='b'></div>
                    <div className='r'></div>
                </div>
            </Roll>
        );
    }
    
export default HtmlCssSection;